import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import logo from '../logo.png'

import {
  FiArrowRight,
  FiCalendar,
  FiCheck,
  FiCheckCircle,
  FiClock,
  FiCreditCard,
  FiHome,
  FiLock,
  FiMenu,
  FiShield,
  FiX
} from 'react-icons/fi'


export default function Home() {

  const [menuOpen, setMenuOpen] =
    useState(false)


  const closeMenu = () => {
    setMenuOpen(false)
  }


  return (

    <div className="
      min-h-screen
      bg-white
      font-[Satoshi]
      text-gray-900
    ">


      {/* ================= NAVBAR ================= */}

      <header className="
        sticky
        top-0
        z-50
        bg-white/95
        backdrop-blur
        border-b
        border-gray-100
      ">

        <div className="
          max-w-[1180px]
          mx-auto
          px-5
          sm:px-6
          lg:px-8
          h-[76px]
          flex
          items-center
          justify-between
        ">


          {/* LOGO */}

          <Link
            to="/"
            className="
              flex
              items-center
              gap-3
            "
          >

            <div className="
              w-10
              h-10
              rounded-xl
              overflow-hidden
              border
              border-gray-100
            ">

              <img
                src={logo}
                alt="RentHub"
                className="
                  w-full
                  h-full
                  object-cover
                "
              />

            </div>


            <span className="
              text-xl
              font-bold
              tracking-tight
            ">
              RentHub
            </span>

          </Link>



          {/* DESKTOP NAV */}

          <nav className="
            hidden
            lg:flex
            items-center
            gap-8
            text-sm
            font-semibold
            text-gray-600
          ">

            <a
              href="#how-it-works"
              className="
                hover:text-gray-900
                transition
              "
            >
              How it works
            </a>

            <a
              href="#benefits"
              className="
                hover:text-gray-900
                transition
              "
            >
              Why RentHub
            </a>

            <a
              href="#repayment"
              className="
                hover:text-gray-900
                transition
              "
            >
              Repayment
            </a>

            <a
              href="#faq"
              className="
                hover:text-gray-900
                transition
              "
            >
              FAQ
            </a>

          </nav>



          {/* DESKTOP ACTIONS */}

          <div className="
            hidden
            lg:flex
            items-center
            gap-3
          ">

            <Link
              to="/auth/signin/"
              className="
                px-4
                py-2.5
                text-sm
                font-semibold
                text-gray-700
                hover:text-gray-900
                transition
              "
            >
              Sign in
            </Link>


            <Link
              to="/auth/signup/"
              className="
                inline-flex
                items-center
                gap-2
                bg-green-600
                hover:bg-green-700
                text-white
                px-5
                py-2.5
                rounded-xl
                text-sm
                font-bold
                transition
              "
            >
              Get started

              <FiArrowRight />
            </Link>

          </div>



          {/* MOBILE MENU BUTTON */}

          <button
            type="button"
            onClick={() =>
              setMenuOpen(
                current => !current
              )
            }
            className="
              lg:hidden
              w-10
              h-10
              rounded-xl
              border
              border-gray-200
              flex
              items-center
              justify-center
              text-xl
            "
            aria-label="Open navigation"
          >

            {
              menuOpen
                ? <FiX />
                : <FiMenu />
            }

          </button>

        </div>



        {/* MOBILE NAV */}

        {menuOpen && (

          <div className="
            lg:hidden
            bg-white
            border-t
            border-gray-100
          ">

            <div className="
              px-5
              py-5
              space-y-1
            ">

              <MobileLink
                href="#how-it-works"
                onClick={closeMenu}
              >
                How it works
              </MobileLink>

              <MobileLink
                href="#benefits"
                onClick={closeMenu}
              >
                Why RentHub
              </MobileLink>

              <MobileLink
                href="#repayment"
                onClick={closeMenu}
              >
                Repayment
              </MobileLink>

              <MobileLink
                href="#faq"
                onClick={closeMenu}
              >
                FAQ
              </MobileLink>


              <div className="
                border-t
                border-gray-100
                pt-4
                mt-4
                grid
                grid-cols-2
                gap-3
              ">

                <Link
                  to="/auth/signin/"
                  onClick={closeMenu}
                  className="
                    h-12
                    border
                    border-gray-300
                    rounded-xl
                    flex
                    items-center
                    justify-center
                    text-sm
                    font-semibold
                  "
                >
                  Sign in
                </Link>


                <Link
                  to="/auth/signup/"
                  onClick={closeMenu}
                  className="
                    h-12
                    bg-green-600
                    text-white
                    rounded-xl
                    flex
                    items-center
                    justify-center
                    text-sm
                    font-bold
                  "
                >
                  Get started
                </Link>

              </div>

            </div>

          </div>

        )}

      </header>



      {/* ================= HERO ================= */}

      <main>

        <section className="
          relative
          overflow-hidden
          bg-[#F7F9FC]
        ">


          <div className="
            absolute
            w-[650px]
            h-[650px]
            rounded-full
            bg-green-100/60
            -right-[300px]
            -top-[270px]
          " />


          <div className="
            max-w-[1180px]
            mx-auto
            px-5
            sm:px-6
            lg:px-8
            pt-16
            pb-20
            lg:pt-24
            lg:pb-28
            relative
          ">


            <div className="
              grid
              grid-cols-1
              lg:grid-cols-[1.05fr_0.95fr]
              gap-12
              lg:gap-16
              items-center
            ">


              {/* HERO COPY */}

              <div>


                <div className="
                  inline-flex
                  items-center
                  gap-2
                  bg-green-50
                  border
                  border-green-100
                  text-green-700
                  rounded-full
                  px-3
                  py-2
                  text-xs
                  font-bold
                  mb-6
                ">

                  <FiHome />

                  RENT FINANCING FOR TENANTS

                </div>


                <h1 className="
                  text-[42px]
                  sm:text-5xl
                  lg:text-[62px]
                  leading-[1.08]
                  font-bold
                  tracking-[-0.04em]
                  text-[#101828]
                ">
                  Pay annual rent.

                  <span className="
                    block
                    text-green-600
                  ">
                    Repay monthly.
                  </span>
                </h1>


                <p className="
                  text-base
                  sm:text-lg
                  text-gray-500
                  leading-8
                  mt-6
                  max-w-2xl
                ">
                  Renthub helps eligible tenants finance their annual rent upfront. Once approved, we pay the landlord and you repay RentHub over 12 months.
                </p>

                <div className="
                  flex
                  flex-col
                  sm:flex-row
                  gap-3
                  mt-8
                ">

                  <Link
                    to="/auth/signup/"
                    className="
                      h-[54px]
                      inline-flex
                      items-center
                      justify-center
                      gap-2
                      bg-green-600
                      hover:bg-green-700
                      text-white
                      px-6
                      rounded-xl
                      font-bold
                      transition
                    "
                  >
                    Apply for rent financing

                    <FiArrowRight />
                  </Link>


                  <a
                    href="#how-it-works"
                    className="
                      h-[54px]
                      inline-flex
                      items-center
                      justify-center
                      border
                      border-gray-300
                      hover:border-gray-400
                      hover:bg-white
                      px-6
                      rounded-xl
                      font-semibold
                      text-gray-700
                      transition
                    "
                  >
                    See how it works
                  </a>

                </div>



                {/* TRUST POINTS */}

                <div className="
                  flex
                  flex-wrap
                  gap-x-6
                  gap-y-3
                  mt-8
                ">

                  <TrustPoint text="BVN verification" />

                  <TrustPoint text="Credit-history assessment" />

                  <TrustPoint text="Secure repayments" />

                </div>

              </div>



              {/* HERO PRODUCT PREVIEW */}

              <div className="
                relative
                max-w-[520px]
                w-full
                mx-auto
              ">


                <div className="
                  absolute
                  -inset-5
                  bg-green-200/30
                  rounded-[36px]
                  blur-2xl
                " />


                <div className="
                  relative
                  bg-[#101828]
                  rounded-[28px]
                  p-5
                  sm:p-7
                  shadow-2xl
                ">


                  <div className="
                    flex
                    justify-between
                    items-center
                    mb-8
                  ">

                    <div>

                      <p className="
                        text-xs
                        text-gray-400
                      ">
                        RentHub financing
                      </p>

                      <p className="
                        text-white
                        font-bold
                        mt-1
                      ">
                        Repayment overview
                      </p>

                    </div>


                    <span className="
                      bg-green-500/10
                      text-green-300
                      px-3
                      py-1.5
                      rounded-full
                      text-xs
                      font-bold
                    ">
                      EXAMPLE
                    </span>

                  </div>



                  <div className="
                    bg-white/5
                    border
                    border-white/10
                    rounded-2xl
                    p-5
                  ">

                    <p className="
                      text-xs
                      text-gray-400
                    ">
                      Annual rent
                    </p>

                    <p className="
                      text-3xl
                      text-white
                      font-bold
                      mt-2
                    ">
                      ₦1,200,000
                    </p>


                    <div className="
                      grid
                      grid-cols-2
                      gap-4
                      mt-6
                    ">

                      <PreviewMetric
                        label="Financing charge"
                        value="₦240,000"
                      />

                      <PreviewMetric
                        label="Total repayment"
                        value="₦1,440,000"
                      />

                    </div>

                  </div>



                  <div className="
                    bg-green-500
                    rounded-2xl
                    p-5
                    mt-4
                    text-white
                  ">

                    <div className="
                      flex
                      items-center
                      justify-between
                      gap-4
                    ">

                      <div>

                        <p className="
                          text-xs
                          text-green-100
                        ">
                          Monthly repayment
                        </p>

                        <p className="
                          text-2xl
                          font-bold
                          mt-1
                        ">
                          ₦120,000
                        </p>

                      </div>


                      <div className="
                        w-12
                        h-12
                        rounded-xl
                        bg-white/10
                        flex
                        items-center
                        justify-center
                        text-xl
                      ">
                        <FiCalendar />
                      </div>

                    </div>


                    <p className="
                      text-xs
                      text-green-100
                      mt-4
                    ">
                      12 monthly repayments
                    </p>

                  </div>



                  <div className="
                    flex
                    items-center
                    gap-3
                    bg-white
                    rounded-2xl
                    p-4
                    mt-4
                  ">

                    <div className="
                      w-10
                      h-10
                      rounded-xl
                      bg-green-50
                      text-green-600
                      flex
                      items-center
                      justify-center
                    ">
                      <FiCheckCircle />
                    </div>


                    <div>

                      <p className="
                        text-sm
                        font-bold
                        text-gray-900
                      ">
                        Landlord paid upfront
                      </p>

                      <p className="
                        text-xs
                        text-gray-400
                        mt-1
                      ">
                        After approval and successful disbursement
                      </p>

                    </div>

                  </div>

                </div>


                <p className="
                  text-xs
                  text-gray-400
                  text-center
                  mt-4
                ">
                  Illustration only. Approval is subject to RentHub's assessment.
                </p>

              </div>

            </div>

          </div>

        </section>



        {/* ================= HOW IT WORKS ================= */}

        <section
          id="how-it-works"
          className="
            scroll-mt-24
            py-20
            lg:py-28
            bg-white
          "
        >

          <SectionContainer>


            <SectionHeading
              eyebrow="HOW IT WORKS"
              title="From rent application to monthly repayment"
              description="A straightforward process designed around annual rent."
            />


            <div className="
              grid
              grid-cols-1
              sm:grid-cols-2
              lg:grid-cols-4
              gap-5
              mt-12
            ">

              <StepCard
                number="01"
                icon={<FiShield />}
                title="Create your account"
                text="Register and verify your identity using your BVN."
              />

              <StepCard
                number="02"
                icon={<FiHome />}
                title="Submit your rent"
                text="Tell us your rent amount, property details and landlord payment information."
              />

              <StepCard
                number="03"
                icon={<FiCheckCircle />}
                title="Application assessment"
                text="RentHub reviews your credit history and determines whether the application can proceed."
              />

              <StepCard
                number="04"
                icon={<FiCreditCard />}
                title="Repay monthly"
                text="After successful landlord disbursement, your 12-month repayment schedule begins."
              />

            </div>

          </SectionContainer>

        </section>



        {/* ================= BENEFITS ================= */}

        <section
          id="benefits"
          className="
            scroll-mt-24
            bg-[#F7F9FC]
            py-20
            lg:py-28
          "
        >

          <SectionContainer>


            <SectionHeading
              eyebrow="WHY RENTHUB"
              title="Annual rent without carrying the entire burden at once"
              description="One financing journey from application to final repayment."
            />


            <div className="
              grid
              grid-cols-1
              lg:grid-cols-3
              gap-6
              mt-12
            ">

              <BenefitCard
                icon={<FiHome />}
                title="Landlord paid upfront"
                text="When your financing is approved and disbursed, RentHub sends the annual rent directly to the landlord account provided in your application."
              />

              <BenefitCard
                icon={<FiCalendar />}
                title="Predictable monthly repayment"
                text="Your annual obligation is converted into a clear 12-month repayment schedule that you can track from your dashboard."
              />

              <BenefitCard
                icon={<FiCreditCard />}
                title="Everything in one place"
                text="See your outstanding balance, repayment dates, transaction history and application status from one RentHub account."
              />

            </div>

          </SectionContainer>

        </section>



        {/* ================= PRODUCT SECTION ================= */}

        <section className="
          py-20
          lg:py-28
          bg-white
        ">

          <SectionContainer>

            <div className="
              grid
              grid-cols-1
              lg:grid-cols-2
              gap-12
              lg:gap-20
              items-center
            ">


              {/* COPY */}

              <div>

                <p className="
                  text-sm
                  font-bold
                  tracking-wide
                  text-green-600
                ">
                  YOUR RENTHUB DASHBOARD
                </p>


                <h2 className="
                  text-3xl
                  lg:text-4xl
                  font-bold
                  tracking-tight
                  mt-3
                  leading-tight
                ">
                  Know exactly where your rent financing stands.
                </h2>


                <p className="
                  text-gray-500
                  leading-7
                  mt-5
                ">
                  Once your loan becomes active, your dashboard gives you a simple view of the numbers and dates that matter.
                </p>


                <div className="
                  space-y-5
                  mt-8
                ">

                  <FeatureLine
                    title="Outstanding balance"
                    text="See how much remains on your RentHub obligation."
                  />

                  <FeatureLine
                    title="Next repayment date"
                    text="Know exactly when your next scheduled payment falls."
                  />

                  <FeatureLine
                    title="Transaction history"
                    text="Review successful repayments from your account."
                  />

                  <FeatureLine
                    title="Loan timeline"
                    text="Track your loan start date, end date and remaining installments."
                  />

                </div>

              </div>



              {/* DASHBOARD MOCK */}

              <div className="
                bg-[#101828]
                rounded-[28px]
                p-5
                sm:p-7
                shadow-xl
              ">


                <div className="
                  flex
                  items-center
                  justify-between
                ">

                  <div>

                    <p className="
                      text-gray-400
                      text-xs
                    ">
                      Outstanding balance
                    </p>

                    <p className="
                      text-white
                      text-3xl
                      font-bold
                      mt-2
                    ">
                      ₦960,000
                    </p>

                  </div>


                  <span className="
                    text-xs
                    font-bold
                    bg-green-500/10
                    text-green-300
                    rounded-full
                    px-3
                    py-2
                  ">
                    ACTIVE
                  </span>

                </div>


                <div className="
                  mt-7
                ">

                  <div className="
                    flex
                    justify-between
                    text-xs
                    text-gray-400
                    mb-2
                  ">

                    <span>
                      Repayment progress
                    </span>

                    <span>
                      33%
                    </span>

                  </div>


                  <div className="
                    h-2
                    rounded-full
                    bg-white/10
                    overflow-hidden
                  ">

                    <div className="
                      h-full
                      w-1/3
                      bg-green-500
                      rounded-full
                    " />

                  </div>

                </div>


                <div className="
                  grid
                  grid-cols-2
                  gap-4
                  mt-6
                ">

                  <DashboardMetric
                    icon={<FiCreditCard />}
                    label="Monthly repayment"
                    value="₦120,000"
                  />

                  <DashboardMetric
                    icon={<FiClock />}
                    label="Installments left"
                    value="8 of 12"
                  />

                </div>


                <div className="
                  bg-white
                  rounded-2xl
                  p-5
                  mt-4
                ">

                  <p className="
                    text-xs
                    text-gray-400
                    uppercase
                    font-semibold
                  ">
                    Next repayment
                  </p>

                  <div className="
                    flex
                    items-center
                    justify-between
                    gap-4
                    mt-2
                  ">

                    <p className="
                      font-bold
                      text-gray-900
                    ">
                      24 October
                    </p>

                    <span className="
                      text-green-600
                      font-bold
                    ">
                      ₦120,000
                    </span>

                  </div>

                </div>

              </div>

            </div>

          </SectionContainer>

        </section>



        {/* ================= REPAYMENT TRANSPARENCY ================= */}

        <section
          id="repayment"
          className="
            scroll-mt-24
            py-20
            lg:py-28
            bg-[#101828]
            text-white
          "
        >

          <SectionContainer>

            <div className="
              grid
              grid-cols-1
              lg:grid-cols-[0.9fr_1.1fr]
              gap-12
              lg:gap-20
              items-center
            ">


              <div>

                <p className="
                  text-sm
                  font-bold
                  text-green-400
                  tracking-wide
                ">
                  CLEAR REPAYMENT STRUCTURE
                </p>


                <h2 className="
                  text-3xl
                  lg:text-4xl
                  font-bold
                  tracking-tight
                  leading-tight
                  mt-3
                ">
                  Understand your obligation before the loan starts.
                </h2>


                <p className="
                  text-gray-400
                  leading-7
                  mt-5
                ">
                  Your RentHub repayment begins after the landlord payment has been successfully disbursed. Your dashboard then tracks the repayment schedule until completion.
                </p>


                <div className="
                  space-y-4
                  mt-8
                ">

                  <DarkFeature
                    text="Loan begins after successful landlord disbursement"
                  />

                  <DarkFeature
                    text="12 scheduled monthly repayments"
                  />

                  <DarkFeature
                    text="Outstanding balance updates as repayments are completed"
                  />

                  <DarkFeature
                    text="Successful payments recorded in your transaction history"
                  />

                </div>

              </div>



              {/* REPAYMENT EXAMPLE */}

              <div className="
                bg-white
                text-gray-900
                rounded-[28px]
                p-6
                sm:p-8
              ">

                <p className="
                  text-xs
                  uppercase
                  tracking-wide
                  font-bold
                  text-green-600
                ">
                  Example repayment
                </p>


                <h3 className="
                  text-2xl
                  font-bold
                  mt-2
                ">
                  ₦1.2m annual rent
                </h3>


                <p className="
                  text-sm
                  text-gray-500
                  mt-2
                ">
                  Illustrative 12-month RentHub financing example.
                </p>


                <div className="
                  divide-y
                  divide-gray-100
                  mt-7
                ">

                  <MoneyRow
                    label="Annual rent"
                    value="₦1,200,000"
                  />

                  <MoneyRow
                    label="Financing charge (20%)"
                    value="₦240,000"
                  />

                  <MoneyRow
                    label="Total repayment"
                    value="₦1,440,000"
                    strong
                  />

                </div>


                <div className="
                  bg-green-50
                  rounded-2xl
                  p-5
                  mt-6
                ">

                  <div className="
                    flex
                    items-end
                    justify-between
                    gap-4
                  ">

                    <div>

                      <p className="
                        text-xs
                        text-green-700
                        font-semibold
                      ">
                        12 monthly repayments
                      </p>

                      <p className="
                        text-2xl
                        font-bold
                        text-green-800
                        mt-1
                      ">
                        ₦120,000
                      </p>

                    </div>


                    <FiCalendar className="
                      text-green-600
                      text-2xl
                    " />

                  </div>

                </div>


                <p className="
                  text-xs
                  text-gray-400
                  leading-5
                  mt-5
                ">
                  This example illustrates the repayment structure only. Financing remains subject to assessment and approval.
                </p>

              </div>

            </div>

          </SectionContainer>

        </section>



        {/* ================= SECURITY ================= */}

        <section className="
          py-20
          lg:py-24
          bg-[#F7F9FC]
        ">

          <SectionContainer>

            <div className="
              bg-white
              border
              border-gray-200
              rounded-[28px]
              p-7
              lg:p-10
              grid
              grid-cols-1
              lg:grid-cols-[1fr_1.2fr]
              gap-10
              items-center
            ">


              <div>

                <div className="
                  w-12
                  h-12
                  rounded-xl
                  bg-green-50
                  text-green-600
                  flex
                  items-center
                  justify-center
                  text-xl
                  mb-5
                ">
                  <FiLock />
                </div>


                <h2 className="
                  text-2xl
                  lg:text-3xl
                  font-bold
                ">
                  Built around secure account access
                </h2>


                <p className="
                  text-gray-500
                  leading-7
                  mt-4
                ">
                  Identity verification, authenticated account access and payment-provider checkout are part of the RentHub customer journey.
                </p>

              </div>


              <div className="
                grid
                grid-cols-1
                sm:grid-cols-3
                gap-4
              ">

                <SecurityCard
                  icon={<FiShield />}
                  title="Identity"
                  text="BVN-backed verification"
                />

                <SecurityCard
                  icon={<FiLock />}
                  title="Account"
                  text="Protected customer access"
                />

                <SecurityCard
                  icon={<FiCreditCard />}
                  title="Payments"
                  text="Secure payment checkout"
                />

              </div>

            </div>

          </SectionContainer>

        </section>



        {/* ================= FAQ ================= */}

        <section
          id="faq"
          className="
            scroll-mt-24
            py-20
            lg:py-28
            bg-white
          "
        >

          <div className="
            max-w-3xl
            mx-auto
            px-5
            sm:px-6
          ">

            <div className="
              text-center
              mb-10
            ">

              <p className="
                text-sm
                font-bold
                tracking-wide
                text-green-600
              ">
                FAQ
              </p>

              <h2 className="
                text-3xl
                lg:text-4xl
                font-bold
                mt-3
              ">
                A few things to know
              </h2>

            </div>


            <div className="
              divide-y
              divide-gray-200
              border-y
              border-gray-200
            ">

              <Faq
                question="How does RentHub work?"
                answer="You create an account, submit your rent and landlord details, and RentHub assesses your application. If approved and successfully disbursed, the landlord receives the annual rent and your monthly repayment schedule begins."
              />

              <Faq
                question="Does creating an account guarantee financing?"
                answer="No. Creating an account or submitting an application does not guarantee approval. Applications are assessed before a financing decision is made."
              />

              <Faq
                question="When does repayment begin?"
                answer="Your RentHub loan begins after the approved landlord payment has been successfully disbursed."
              />

              <Faq
                question="Where can I track my repayments?"
                answer="Active customers can view their outstanding balance, next payment date, repayment progress and transaction history directly from the RentHub dashboard."
              />

            </div>

          </div>

        </section>



        {/* ================= FINAL CTA ================= */}

        <section className="
          px-5
          sm:px-6
          pb-20
          lg:pb-28
        ">

          <div className="
            max-w-[1180px]
            mx-auto
            bg-green-600
            rounded-[30px]
            px-6
            py-12
            sm:px-10
            lg:px-14
            lg:py-14
            text-white
            relative
            overflow-hidden
          ">


            <div className="
              absolute
              w-80
              h-80
              rounded-full
              bg-white/10
              -right-32
              -top-40
            " />


            <div className="
              relative
              flex
              flex-col
              lg:flex-row
              lg:items-center
              lg:justify-between
              gap-8
            ">

              <div className="
                max-w-2xl
              ">

                <p className="
                  text-green-100
                  text-sm
                  font-semibold
                ">
                  READY TO GET STARTED?
                </p>

                <h2 className="
                  text-3xl
                  lg:text-4xl
                  font-bold
                  tracking-tight
                  mt-2
                ">
                  Make annual rent easier to manage.
                </h2>

                <p className="
                  text-green-100
                  leading-7
                  mt-4
                ">
                  Create your RentHub account and submit your rent financing application.
                </p>

              </div>


              <div className="
                flex
                flex-col
                sm:flex-row
                gap-3
                shrink-0
              ">

                <Link
                  to="/auth/signup/"
                  className="
                    h-[52px]
                    bg-white
                    hover:bg-gray-100
                    text-gray-900
                    px-6
                    rounded-xl
                    font-bold
                    flex
                    items-center
                    justify-center
                    gap-2
                    transition
                  "
                >
                  Create account

                  <FiArrowRight />
                </Link>


                <Link
                  to="/auth/signin/"
                  className="
                    h-[52px]
                    border
                    border-white/30
                    hover:bg-white/10
                    px-6
                    rounded-xl
                    font-semibold
                    flex
                    items-center
                    justify-center
                    transition
                  "
                >
                  Sign in
                </Link>

              </div>

            </div>

          </div>

        </section>

      </main>



      {/* ================= FOOTER ================= */}

      <footer className="
        bg-[#101828]
        text-white
      ">

        <div className="
          max-w-[1180px]
          mx-auto
          px-5
          sm:px-6
          lg:px-8
          py-12
        ">

          <div className="
            grid
            grid-cols-1
            md:grid-cols-[1.3fr_0.7fr_0.7fr]
            gap-10
          ">


            <div>

              <Link
                to="/"
                className="
                  inline-flex
                  items-center
                  gap-3
                "
              >

                <div className="
                  w-10
                  h-10
                  rounded-xl
                  overflow-hidden
                  bg-white
                ">

                  <img
                    src={logo}
                    alt="RentHub"
                    className="
                      w-full
                      h-full
                      object-cover
                    "
                  />

                </div>


                <span className="
                  text-xl
                  font-bold
                ">
                  RentHub
                </span>

              </Link>


              <p className="
                text-sm
                text-gray-400
                leading-6
                mt-5
                max-w-md
              ">
                Rent financing built around annual landlord payments and manageable monthly repayments.
              </p>

            </div>



            <div>

              <p className="
                text-sm
                font-bold
              ">
                RentHub
              </p>

              <div className="
                flex
                flex-col
                gap-3
                mt-4
                text-sm
                text-gray-400
              ">

                <a
                  href="#how-it-works"
                  className="
                    hover:text-white
                    transition
                  "
                >
                  How it works
                </a>

                <a
                  href="#benefits"
                  className="
                    hover:text-white
                    transition
                  "
                >
                  Why RentHub
                </a>

                <a
                  href="#faq"
                  className="
                    hover:text-white
                    transition
                  "
                >
                  FAQ
                </a>

              </div>

            </div>



            <div>

              <p className="
                text-sm
                font-bold
              ">
                Account
              </p>

              <div className="
                flex
                flex-col
                gap-3
                mt-4
                text-sm
                text-gray-400
              ">

                <Link
                  to="/auth/signin/"
                  className="
                    hover:text-white
                    transition
                  "
                >
                  Sign in
                </Link>

                <Link
                  to="/auth/signup/"
                  className="
                    hover:text-white
                    transition
                  "
                >
                  Create account
                </Link>

              </div>

            </div>

          </div>


          <div className="
            border-t
            border-white/10
            mt-10
            pt-6
            flex
            flex-col
            sm:flex-row
            sm:items-center
            sm:justify-between
            gap-3
          ">

            <p className="
              text-xs
              text-gray-500
            ">
              © 2026 RentHub. All rights reserved.
            </p>


            <p className="
              text-xs
              text-gray-500
            ">
              Rent financing is subject to assessment and approval.
            </p>

          </div>

        </div>

      </footer>

    </div>
  )
}



/* ============================================================
   SMALL COMPONENTS
============================================================ */


function SectionContainer({
  children
}) {

  return (

    <div className="
      max-w-[1180px]
      mx-auto
      px-5
      sm:px-6
      lg:px-8
    ">
      {children}
    </div>
  )
}



function SectionHeading({
  eyebrow,
  title,
  description
}) {

  return (

    <div className="
      max-w-2xl
    ">

      <p className="
        text-sm
        font-bold
        tracking-wide
        text-green-600
      ">
        {eyebrow}
      </p>


      <h2 className="
        text-3xl
        lg:text-4xl
        font-bold
        tracking-tight
        leading-tight
        mt-3
      ">
        {title}
      </h2>


      <p className="
        text-gray-500
        leading-7
        mt-4
      ">
        {description}
      </p>

    </div>
  )
}



function TrustPoint({
  text
}) {

  return (

    <div className="
      flex
      items-center
      gap-2
      text-sm
      text-gray-500
    ">

      <div className="
        w-5
        h-5
        bg-green-100
        text-green-700
        rounded-full
        flex
        items-center
        justify-center
        text-xs
      ">
        <FiCheck />
      </div>

      {text}

    </div>
  )
}



function PreviewMetric({
  label,
  value
}) {

  return (

    <div>

      <p className="
        text-xs
        text-gray-400
      ">
        {label}
      </p>

      <p className="
        text-sm
        text-white
        font-bold
        mt-1
      ">
        {value}
      </p>

    </div>
  )
}



function StepCard({
  number,
  icon,
  title,
  text
}) {

  return (

    <div className="
      bg-white
      border
      border-gray-200
      rounded-2xl
      p-6
      hover:shadow-md
      transition
    ">

      <div className="
        flex
        items-center
        justify-between
      ">

        <div className="
          w-11
          h-11
          bg-green-50
          text-green-600
          rounded-xl
          flex
          items-center
          justify-center
          text-xl
        ">
          {icon}
        </div>


        <span className="
          text-xs
          font-bold
          text-gray-300
        ">
          {number}
        </span>

      </div>


      <h3 className="
        text-lg
        font-bold
        mt-6
      ">
        {title}
      </h3>


      <p className="
        text-sm
        text-gray-500
        leading-6
        mt-2
      ">
        {text}
      </p>

    </div>
  )
}



function BenefitCard({
  icon,
  title,
  text
}) {

  return (

    <div className="
      bg-white
      border
      border-gray-200
      rounded-2xl
      p-7
      shadow-sm
    ">

      <div className="
        w-12
        h-12
        bg-green-50
        text-green-600
        rounded-xl
        flex
        items-center
        justify-center
        text-xl
      ">
        {icon}
      </div>


      <h3 className="
        text-xl
        font-bold
        mt-6
      ">
        {title}
      </h3>


      <p className="
        text-sm
        text-gray-500
        leading-7
        mt-3
      ">
        {text}
      </p>

    </div>
  )
}



function FeatureLine({
  title,
  text
}) {

  return (

    <div className="
      flex
      gap-4
    ">

      <div className="
        w-6
        h-6
        shrink-0
        rounded-full
        bg-green-100
        text-green-700
        flex
        items-center
        justify-center
        text-xs
        mt-0.5
      ">
        <FiCheck />
      </div>


      <div>

        <p className="
          font-bold
        ">
          {title}
        </p>

        <p className="
          text-sm
          text-gray-500
          leading-6
          mt-1
        ">
          {text}
        </p>

      </div>

    </div>
  )
}



function DashboardMetric({
  icon,
  label,
  value
}) {

  return (

    <div className="
      bg-white/5
      border
      border-white/10
      rounded-2xl
      p-4
    ">

      <div className="
        text-green-400
        text-lg
      ">
        {icon}
      </div>


      <p className="
        text-xs
        text-gray-400
        mt-4
      ">
        {label}
      </p>

      <p className="
        text-white
        font-bold
        mt-1
      ">
        {value}
      </p>

    </div>
  )
}



function DarkFeature({
  text
}) {

  return (

    <div className="
      flex
      items-start
      gap-3
    ">

      <div className="
        w-6
        h-6
        shrink-0
        rounded-full
        bg-green-500/10
        text-green-400
        flex
        items-center
        justify-center
        text-xs
        mt-0.5
      ">
        <FiCheck />
      </div>

      <p className="
        text-sm
        text-gray-300
        leading-6
      ">
        {text}
      </p>

    </div>
  )
}



function MoneyRow({
  label,
  value,
  strong = false
}) {

  return (

    <div className="
      flex
      items-center
      justify-between
      gap-5
      py-4
    ">

      <span className="
        text-sm
        text-gray-500
      ">
        {label}
      </span>

      <span className={`
        text-sm
        text-right

        ${
          strong
            ? 'font-bold text-gray-900'
            : 'font-semibold text-gray-800'
        }
      `}>
        {value}
      </span>

    </div>
  )
}



function SecurityCard({
  icon,
  title,
  text
}) {

  return (

    <div className="
      bg-[#F7F9FC]
      rounded-2xl
      p-5
    ">

      <div className="
        text-green-600
        text-xl
      ">
        {icon}
      </div>

      <p className="
        font-bold
        mt-4
      ">
        {title}
      </p>

      <p className="
        text-xs
        text-gray-500
        leading-5
        mt-1
      ">
        {text}
      </p>

    </div>
  )
}



function Faq({
  question,
  answer
}) {

  return (

    <details className="
      group
      py-6
    ">

      <summary className="
        cursor-pointer
        list-none
        flex
        items-center
        justify-between
        gap-5
        font-bold
        text-gray-900
      ">

        {question}


        <span className="
          w-8
          h-8
          rounded-full
          bg-gray-100
          flex
          items-center
          justify-center
          text-lg
          font-normal
          group-open:rotate-45
          transition-transform
        ">
          +
        </span>

      </summary>


      <p className="
        text-sm
        text-gray-500
        leading-7
        mt-4
        pr-10
      ">
        {answer}
      </p>

    </details>
  )
}



function MobileLink({
  href,
  children,
  onClick
}) {

  return (

    <a
      href={href}
      onClick={onClick}
      className="
        flex
        items-center
        h-11
        text-sm
        font-semibold
        text-gray-700
      "
    >
      {children}
    </a>
  )
}